import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput, AbcdInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar, Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from "store2";
import Client from "../../helpers/ApiClient";
import FilterGroupsInput from "../../components/Form/FilterGroupsInput";
import moment from "moment";

@connect((state, props) => {
	return {
		state: state.datagrids.get('driver')
	};
})
class HeaderFilter extends Component {
	render() {
		return (
			<div style={{marginBottom: 10}}>
				<FilterField filter={this.props.filter} field="letter"/>
			</div>
		)
	}
}

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/driver/' + row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

		const rendererFiles = (val, row) => {
			const files = row.files.map(file => {
				const tooltip = <Tooltip id="file">{file.title}</Tooltip>
				return (
					<OverlayTrigger key={file.id} placement="top" overlay={tooltip}>
						<a style={{color: '#000'}} href={'/file/download/' + file.id}>
							<i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip"/>
						</a>
					</OverlayTrigger>
				)
			});
			return <div>
				{files}
			</div>
		};

		this.columnModel = [
			{
				name: 'surname',
				title: 'Příjmení',
				field: 'surname',
				renderer: rendererLink
			},
			{
				name: 'name',
				title: 'Jméno',
				field: 'name',
				renderer: rendererLink
			},
			{
				name: 'born',
				title: 'Dat. nar.',
				field: 'born',
				width: 90,
				renderer: Renderers.Date
			},
			{
				name: 'personal_number',
				title: 'Os. číslo',
				field: 'personal_number'
			},
			{
				name: 'cTitle',
				title: 'Firma',
				field: 'cTitle',
				width: 300,
			},
			{
				name: 'omv_number',
				title: 'Průkaz OMV',
				field: 'omv_number'
			},
			{
				name: 'op',
				title: 'Oprávnění',
				field: 'op',
				width: 130,
				sortable: false
			},
			{
				name: 'omv_expired',
				title: <span>Platnost&nbsp;do</span>,
				field: 'omv_expired',
				renderer: Renderers.Date
			},
			/*{
				name: 'ev',
				title: 'Ev. č.',
				field: 'ev',
				width:70
			},*/
			{
				name: 'files',
				width: 58,
				title: <i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip"/>,
				sortable: false,
				renderer: rendererFiles
			},
			{
				name: 'active',
				title: 'e-šk',
				field: 'active',
				width: 60,
				align:'center',
				renderer: Renderers.CheckThin
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width: 80,
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/driver/' + val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i>Upravit
						</a>
					);
				}
			}
		];

		const filterSchema = {
			surname: {class: FilterInput},
			ev: {class: FilterInput},
			letter: {class: AbcdInput},
			name: {class: FilterInput},
			personal_number: {class: FilterInput},
			omv_number: {class: FilterInput},
			cTitle: {class: FilterInput},
      op: {class: FilterGroupsInput},
			rmv_number: {class: FilterInput},
			born: {class: DateRange},
			omv_expired: {class: DateRange, opens: 'left', ranges: {
          //'Tento týden': [moment().startOf('isoweek'), moment().endOf('isoweek')],
          'Tento měsíc': [moment().startOf('month'), moment().endOf('month')],
          //'Příští týden': [moment().add(1, 'week').startOf('isoweek'), moment().add(1, 'week').endOf('isoweek')],
          'Příští měsíc': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')],
          //'Minulý týden': [moment().subtract(1, 'week').startOf('isoweek'), moment().subtract(1, 'week').endOf('isoweek')],
          'Minulý měsíc': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          'Dnes': [moment(), moment()],
        }},
			active: { class: Select, options: DbInfo.YesNo },
			fulltext: {class: SearchInput},
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-driver');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {
			column: 'surname',
			'direction': 'asc'
		};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('driver.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('driver.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('driver', row.surname + ' ' + row.name, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

  printEU(type, multiAction) {
    const api = new Client();
    api.call('driver.downloadMulti', {multiAction: multiAction, type}, {progress: true}).then((data) => {
      if (data) {
        var win = window.open(data.url, '_blank');
        if(win) {
          win.focus();
        } else{
          alert('Povolte prosím v prohlížeči vyskakovací okna pro tuto aplikaci.');
        }
      }
    });
  }

  cancelSelection() {
    this.refs.datagrid.getWrappedInstance().resetSelection();
  }

  render() {

		const buttons = <Button href="/driver/0" onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový řidič
		</Button>;

    const actions = [
      {title: 'Průkazy EU', onClick:(multiAction) => this.printEU(5, multiAction)},
      {title: 'Průkazy podnikové', onClick:(multiAction) => this.printEU(7, multiAction)},
      {title: 'Zrušit výběr', onClick:(multiAction) => this.cancelSelection()},
    ];

    const header = <HeaderFilter filter={this.filter}/>;

		return (
			<Datagrid
				ref="datagrid"
				id="driver"
				api="driver.getList"
				buttons={buttons}
				header={header}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
        multiActions={actions}
        defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Driver/List.js